import { useId } from 'react'

/** GCodr mark (striped peak) and wordmark, cyan → blue. */
export default function Logo({ glow = true }: { glow?: boolean }) {
  const id = useId().replace(/:/g, '')
  return (
    <span className="flex items-center gap-2.5">
      <svg width="24" height="19" viewBox="0 0 32 28" fill="none" aria-hidden="true">
        <defs>
          <clipPath id={`mtn-${id}`}>
            <path d="M2 27 C5 27 7 22 9 18 C11 14 13 10 16 7 C19 10 21 14 23 18 C25 22 27 27 30 27 Z" />
          </clipPath>
          <linearGradient id={`g-${id}`} x1="2" y1="7" x2="30" y2="27" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#06b6d4" />
            <stop offset="100%" stopColor="#3b82f6" />
          </linearGradient>
        </defs>
        <g clipPath={`url(#mtn-${id})`}>
          {[7, 10.5, 14, 17.5, 21].map(y => <rect key={y} x="0" y={y} width="32" height="2" fill={`url(#g-${id})`} />)}
          <rect x="0" y="24.5" width="32" height="3" fill={`url(#g-${id})`} />
        </g>
      </svg>
      <span
        className="select-none font-display text-base font-black uppercase tracking-widest"
        style={{
          background: 'linear-gradient(135deg, #06b6d4, #3b82f6)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          filter: glow ? 'drop-shadow(0 0 8px rgba(6,182,212,0.5))' : undefined,
        }}
      >
        GCODR
      </span>
    </span>
  )
}
